<template>
  <td 
    data-label="Id"
    class="table--id"
  >
    <p>{{ id }}</p>
  </td>
</template>

<script>
  export default {
    name: 'TdId',
    props: [
      'id'
    ]
  }
</script>

<style lang="scss">
  .table--id {
  }
</style>
